import { atom } from 'jotai';
import { MemberMessageStatus, Message } from '../typings/message-types';
import { FrequencyCappingState } from '../../../../shared/typings/frequency-capping';

interface BroadcastMessageInfo {
  messageId: string;
  chatId: string;
  pageDetail: string;
  buttonText: string;
  chatTypeId: string;
  linkId: string;
  cardIndex?: number;
  nextScheduledAt?: string;
  retryFailedMessages?: boolean;
  showRetrySettings?: boolean;
  frequencyCappingState?: FrequencyCappingState;
  showTemplateInfo?: boolean;
}

type MessageInfo = {
  message: Message;
  customerId: string;
  chatId: string;
};

interface BroadcastMembersInfo {
  channelId: string;
}
interface BroadcastMsgDetailsType {
  messageId: string;
  chatId: string;
  channelId: string;
}

interface WaGroupMessageInfo {
  message: Message;
  memberMessageStatuses: MemberMessageStatus[];
}

export enum CallSidebarTabType {
  Transcript = 'transcript',
  Summary = 'summary',
}

interface CallSidebarTab {
  tab: CallSidebarTabType;
  fullMessage: Message;
}

export enum DetailsPanelState {
  NONE = 'none',
  CUSTOMER_DETAILS = 'customer-details',
  WA_GROUP_DETAILS = 'wa-group-details',
  BROADCAST_MESSAGE = 'broadcast-message',
  MESSAGE_INFO = 'message-info',
  WA_GROUP_MESSAGE_INFO = 'wa-group-message-info',
  BROADCAST_MEMBERS = 'broadcast-members',
  AI_CHAT_SUMMARY = 'ai-chat-summary',
  SEARCH = 'search',
  AI_CALL_SUMMARY = 'ai-call-summary',
  SCHEDULED_MESSAGES = 'scheduled-messages',
}

type DetailsPanelAtom =
  | {
      open: false;
    }
  | (
      | {
          open: boolean;
          type: DetailsPanelState.CUSTOMER_DETAILS;
        }
      | {
          open: boolean;
          type: DetailsPanelState.WA_GROUP_DETAILS;
        }
      | { open: boolean; type: DetailsPanelState.MESSAGE_INFO; data: MessageInfo }
      | { open: boolean; type: DetailsPanelState.WA_GROUP_MESSAGE_INFO; data: WaGroupMessageInfo }
      | {
          open: boolean;
          type: DetailsPanelState.BROADCAST_MESSAGE;
          data: BroadcastMessageInfo;
        }
      | {
          open: boolean;
          type: DetailsPanelState.BROADCAST_MEMBERS;
          data: BroadcastMembersInfo;
        }
      | {
          open: boolean;
          type: DetailsPanelState.AI_CHAT_SUMMARY;
        }
      | {
          open: boolean;
          type: DetailsPanelState.SEARCH;
        }
      | {
          open: boolean;
          type: DetailsPanelState.AI_CALL_SUMMARY;
          data: CallSidebarTab;
        }
      | {
          open: boolean;
          type: DetailsPanelState.SCHEDULED_MESSAGES;
        }
    );

export const detailsPanelAtom = atom<DetailsPanelAtom>({
  open: false,
});
